export function SpaceCertLabelTag(props: { name: string }): JSX.Element {
  const text = props.name.trim();
  return (
    <span className="space-home-verify space-home-verify--cert">
      <img
        src="/icons/verified.svg"
        className="space-home-verify-icon"
        alt=""
        aria-hidden
      />
      {text}
    </span>
  );
}
